var map = {
	"./Ball-0.9s-200px.svg": "51b5",
	"./Boti.svg": "60ba",
	"./bank-connected-big.svg": "60d0",
	"./bank_square_bottom.svg": "43cf",
	"./bank_square_top.svg": "fbfb",
	"./big-icon-alert.svg": "2212",
	"./big-icon-eclipse.svg": "b9e9",
	"./big-icon-rising.svg": "ad0d",
	"./big-icon-unsupported.svg": "1d78",
	"./cards_square_bottom.svg": "3c0a",
	"./cards_square_top.svg": "7658",
	"./cashflow-loader/arrows.svg": "f6d2",
	"./cashflow-loader/pyramid.svg": "5605",
	"./cashflow-loader/sun.svg": "a393",
	"./cashflow-loader/wave.svg": "25d7",
	"./creds-coffee-cup.svg": "2355",
	"./emun_black_white.svg": "31c7",
	"./expenses_square_bottom.svg": "7cfe",
	"./expenses_square_top.svg": "a51a",
	"./header-bank-square-bottom.svg": "9de1",
	"./icons/arrow-up.svg": "554d",
	"./icons/bank-icon-disabled.svg": "f27d",
	"./icons/bank-icon.svg": "50eb",
	"./icons/big-icon-discount-incomplete.svg": "08ef",
	"./icons/big-icon-unsupported.svg": "0f46",
	"./icons/check-blue.svg": "a443",
	"./icons/ic-chevron-down-black.svg": "cbc8",
	"./icons/ic-chevron-up-black.svg": "6455",
	"./icons/icon-add.svg": "13d9",
	"./icons/icon-lock.svg": "29a8",
	"./icons/icon-remove.svg": "7c07",
	"./icons/icon-small-check.svg": "a155",
	"./icons/icon-small-lock.svg": "7e2b",
	"./icons/left-arrow.svg": "192b",
	"./icons/no-icon.svg": "7775",
	"./icons/pending-joint.svg": "9ba0",
	"./icons/play-btn.svg": "d2b8",
	"./icons/privacy.svg": "a581",
	"./icons/shield-icon.svg": "edff",
	"./icons/shield-square.svg": "d07d",
	"./icons/shield_square.svg": "5b95",
	"./icons/wait-icon.svg": "6146",
	"./icons/whatsapp.svg": "d7c5",
	"./incomes_bottom_square.svg": "ea54",
	"./incomes_square_top.svg": "f568",
	"./iso-logo.svg": "a6f8",
	"./mti_logo.svg": "975a",
	"./past_month_balance.svg": "8324",
	"./safe.svg": "b269",
	"./safe2.svg": "1227",
	"./safe3.svg": "e75c",
	"./secVidImg.png": "7c77",
	"./security-logos.svg": "ad21",
	"./security-top-image.svg": "a068",
	"./spinner-big.svg": "0868",
	"./trust-logos.svg": "2c27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7202";